import {
    useMutation,
    useQuery,
} from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Delete, Get, Post, Put } from "../api";
import API_CONSTANTS from "../constants/api";
import { prepareData } from "../helpers/apiHelper";
import { MILISECONDS } from "../constants";
import { appendQueryParams } from "../helpers/queryHelper";;

export const useCohorts = (params) => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["cohorts", params],
        queryFn: async () => {
            const { data } = await Get({
                path: `${API_CONSTANTS.COHORTS.base}?${appendQueryParams({ params })}`,
                token,
                toastError: true,
            })
            return data
        },
        keepPreviousData: true
    })
}

export const useCohort = (id) => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["cohort", id],
        queryFn: async () => {
            const { data } = await Get({
                path: `${API_CONSTANTS.COHORTS.base}/${id}`,
                token,
                toastError: true,
            })
            return data
        },
        enabled: !!id
    })
}
export const useCohortsFacet = () => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["cohortsFacet"],
        queryFn: async () => {
            const { data } = await Get({
                path: API_CONSTANTS.COHORTS.getFacet,
                token,
                toastError: true,
            })
            return data
        },
    })
}

export const useCohortOptions = (params = {}) => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["cohortOptions", params],
        queryFn: async () => {
            const { data } = await Get({
                path: `${API_CONSTANTS.COHORTS.getOptions}?${appendQueryParams({params})}`,
                token,
                toastError: true,
            })
            console.log(data,"sajkdasjkdhasjkdhaskjd")
            return data
        },
        staleTime: MILISECONDS.MAX
    })
}


export const useCreateCohort = () => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (body) => {
            body = prepareData(body, API_CONSTANTS.COHORTS.dataKeys)
            const { data } = await Post({
                path: API_CONSTANTS.COHORTS.base,
                token,
                body,
                toastError: true,
                toastMessage: true
            })
            return data
        },
    })
}

export const useUpdateCohort = () => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (body) => {
            body = prepareData(body, API_CONSTANTS.COHORTS.dataKeys)
            const { data } = await Put({
                path: `${API_CONSTANTS.COHORTS.base}/${body.id}`,
                token,
                body,
                toastError: true,
                toastMessage: true
            })
            return data
        },
    })
}

export const useDeleteCohort = () => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (id) => {
            const { data } = await Delete({
                path: `${API_CONSTANTS.COHORTS.base}/${id}`,
                token,
                toastError: true,
                toastMessage: true
            })
            return data
        },
    })
}